import { Link } from 'react-router-dom';
import classNames from 'classnames/bind';
import moment from 'moment';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFileAlt } from '@fortawesome/pro-regular-svg-icons/faFileAlt';

import capitalize from '../../../../../../helpers/capitalize';
import { checkAndRoun } from '../../../../../../helpers/topicsHelpers';
import { convertPermalinkToPath } from '../../../../../../helpers/urlHelpers';

import ClassParticularsCell from '../../ClassParticularsCell';
import Tooltip from '../../../../../Tooltip';

import Styles from '../styles.module.scss';

const cx = classNames.bind(Styles);

const TableSection = (props) => {
  const {
    currentPage, pageSize, currentData, totalValue, hasAdjusted, hasInsightsAccess,
  } = props;

  return (
    <div className={Styles['shares-allotment-table-holder']}>
      <table className={cx('shares-allotment-table', { new_loading: currentData.newLoading, no_access: !hasInsightsAccess })}>
        <thead className={Styles['shares-allotment-table-header']}>
          <tr className={Styles['shares-allotment-table-header-row']}>
            <th className={cx('shares-allotment-table-header-cell', 'rowNumber')}>#</th>
            <th className={cx('shares-allotment-table-header-cell', 'date')}>
              <div className={Styles.sharePrice_tooltip_holder}>
                <span>
                  Date of Allotment
                </span>
                <Tooltip
                  newIcon
                  hasBigScreenDesign
                  isCentered
                  className={Styles.sharePrice_tooltip}
                >
                  Date the shares were issued.
                </Tooltip>
              </div>
            </th>
            <th className={cx('shares-allotment-table-header-cell', 'classOfShare')}>Class of Shares</th>
            <th className={cx('shares-allotment-table-header-cell', 'classParticulars')}>
              <div className={Styles.sharePrice_tooltip_holder}>
                <span>
                  Class Particulars
                </span>
                <Tooltip
                  newIcon
                  hasBigScreenDesign
                  isCentered
                  className={Styles.sharePrice_tooltip}
                >
                  Descriptions and rights of share class.
                </Tooltip>
              </div>
            </th>
            <th className={cx('shares-allotment-table-header-cell', 'numberOfShares')}>
              <div className={Styles.sharePrice_tooltip_holder}>
                <span>
                  Number of Shares
                </span>
                <Tooltip
                  newIcon
                  hasBigScreenDesign
                  isCentered
                  className={Styles.sharePrice_tooltip}
                >
                  The number of shares issued in the allotment event, as extracted from the filing.
                </Tooltip>
              </div>
            </th>
            {hasAdjusted && (
              <th className={cx('shares-allotment-table-header-cell', 'adjustedNumberOfShares')}>
                <div className={Styles.sharePrice_tooltip_holder}>
                  <span>
                    Adjusted Number
                    <br />
                    of Shares
                  </span>
                  <Tooltip
                    newIcon
                    hasBigScreenDesign
                    isCentered
                    className={Styles.sharePrice_tooltip}
                  >
                    The number of shares issued in the allotment event, adjusted for splits.
                  </Tooltip>
                </div>
              </th>
            )}
            <th className={cx('shares-allotment-table-header-cell', 'currency')}>Currency</th>
            <th className={cx('shares-allotment-table-header-cell', 'sharePrice')}>
              <div className={Styles.sharePrice_tooltip_holder}>
                <span>
                  Price Per Share
                  <br />
                  As Per Filings
                </span>
                <Tooltip
                  newIcon
                  hasBigScreenDesign
                  isCentered
                  className={Styles.sharePrice_tooltip}
                >
                  The price per share for the share class in the allotment event,
                  as extracted from the filing.
                </Tooltip>
              </div>
            </th>
            <th className={cx('shares-allotment-table-header-cell', 'adjustedSharePrice')}>
              <div className={Styles.sharePrice_tooltip_holder}>
                <span>
                  Adjusted Price
                  <br />
                  Per Share
                </span>
                <Tooltip
                  newIcon
                  hasBigScreenDesign
                  isCentered
                  className={Styles.sharePrice_tooltip}
                >
                  The price per share for the share class in the allotment event,
                  adjusted for splits.
                </Tooltip>
              </div>
            </th>
            <th className={cx('shares-allotment-table-header-cell', 'amountRaised')}>
              <div className={Styles.sharePrice_tooltip_holder}>
                <span>
                  Amount Raised
                </span>
                <Tooltip
                  newIcon
                  hasBigScreenDesign
                  isCentered
                  dynamicPosition
                  contentStyle={{ left: 0 }}
                  className={Styles.sharePrice_tooltip}
                >
                  The amount raised for the share class in the allotment event.
                </Tooltip>
              </div>
            </th>
          </tr>
        </thead>
        <tbody className={Styles['shares-allotment-table-body']}>
          {!hasInsightsAccess && (
            <tr className={Styles['shares-allotment-access']}>
              <td
                colSpan="10"
                className={Styles['shares-allotment-access-cell']}
              >
                <div className={Styles['shares-allotment-access-body']}>
                  <div className={Styles['shares-allotment-access-message']}>
                    <Link to="/pricing">Upgrade to UK Insights</Link>
                    {' '}
                    to use this feature.
                  </div>
                </div>
              </td>
            </tr>
          )}
          <tr
            className={cx('shares-allotment-table-body-row', 'total_row')}
          >
            <td className={cx('shares-allotment-table-body-cell')} />
            <td className={cx('shares-allotment-table-body-cell')} />
            <td className={cx('shares-allotment-table-body-cell')}>
              TOTAL
            </td>
            <td className={cx('shares-allotment-table-body-cell')} />
            <td className={cx('shares-allotment-table-body-cell', 'numberOfShares')}>
              {totalValue.numberOfShares ? Number((totalValue.numberOfShares)).toLocaleString() : '-'}
            </td>
            {hasAdjusted && (
              <td className={cx('shares-allotment-table-body-cell', 'adjustedNumberOfShares')}>
                {totalValue.adjustedNumberOfShares ? Number((totalValue.adjustedNumberOfShares)).toLocaleString() : '-'}
              </td>
            )}
            <td className={cx('shares-allotment-table-body-cell')} />
            <td className={cx('shares-allotment-table-body-cell')} />
            <td className={cx('shares-allotment-table-body-cell')} />
            <td className={cx('shares-allotment-table-body-cell', 'amountRaised')}>
              {totalValue.amountRaised ? checkAndRoun(totalValue.amountRaised, 2, true) : '-'}
            </td>
          </tr>
          {currentData.data
            .slice(((currentPage - 1) * pageSize), (((currentPage - 1) * pageSize) + pageSize))
            .map((obj, i) => (
              <tr
                // eslint-disable-next-line react/no-array-index-key
                key={i}
                className={Styles['shares-allotment-table-body-row']}
              >
                <td className={cx('shares-allotment-table-body-cell', 'rowNumber')}>
                  {((currentPage - 1) * pageSize) + (i + 1)}
                </td>
                <td className={cx('shares-allotment-table-body-cell', 'date')}>
                  {obj.date ? moment(obj.date, 'YYYY-MM-DD').format('DD MMM YYYY') : ''}
                </td>
                <td className={cx('shares-allotment-table-body-cell', 'classOfShare')}>
                  {capitalize(obj.class)}
                </td>
                <td className={cx('shares-allotment-table-body-cell', 'classParticulars')}>
                  <ClassParticularsCell
                    value={obj.classParticulars}
                  />
                </td>
                <td className={cx('shares-allotment-table-body-cell', 'numberOfShares')}>
                  {(obj.numberOfShares || '').toLocaleString() || '-'}
                </td>
                {hasAdjusted && (
                  <td className={cx('shares-allotment-table-body-cell', 'adjustedNumberOfShares')}>
                    {(obj.adjustedNumberOfShares || '').toLocaleString() || '-'}
                  </td>
                )}
                <td className={cx('shares-allotment-table-body-cell', 'currency')}>{obj.currency}</td>
                <td className={cx('shares-allotment-table-body-cell', 'sharePrice')}>
                  {obj.sharePrice ? checkAndRoun(obj.sharePrice, 2, false, false, true) : '-'}
                  <Tooltip
                    hasBigScreenDesign
                    className={Styles.infoIcon_tooltip}
                    icon={(
                      <Link
                        className={Styles.infoIcon}
                        to={convertPermalinkToPath(obj.url)}
                      >
                        <FontAwesomeIcon icon={faFileAlt} />
                      </Link>
                    )}
                  >
                    View document
                  </Tooltip>
                </td>
                <td className={cx('shares-allotment-table-body-cell', 'adjustedSharePrice')}>
                  {checkAndRoun(obj.adjustedSharePrice, 2, true, true, true)}
                </td>
                <td className={cx('shares-allotment-table-body-cell', 'amountRaised')}>
                  {obj.amountRaised ? checkAndRoun(obj.amountRaised, 2, true, true, true) : '-'}
                </td>
              </tr>
            ))}
        </tbody>
      </table>
    </div>
  );
};

export default TableSection;
